import React, { useEffect } from "react";
import Markup from "./markup/Markup";
import "./css/plugins.css";
import "./css/style.css";
import "./css/templete.css";
import "./css/skin/skin.css";

function App() {
    useEffect(() => {
        const onScroll = () => {
            const header = document.querySelector(".main-bar-wraper");
            header && header.classList.toggle("is-fixed", window.scrollY > 10);
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="App">
            <Markup />
        </div>
    );
}

export default App;
